module.exports = __webpack_public_path__ + "static/img/aojiabao.69861d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/aojiabao.jpg
// module id = NbBv
// module chunks = 0